(function () {
  'use strict';

  if (window.cardProductVariantImageReady) return;
  window.cardProductVariantImageReady = true;

  function setActiveSwatch(swatch) {
    const swatchGroup = swatch.closest('.card__color_variants');

    if (!swatchGroup) return;

    swatchGroup.querySelectorAll('.card__color_variants-swatch').forEach(function (item) {
      const isActive = item === swatch;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updateSlider(card, swatch) {
    const slider = card.querySelector('.card-img-slider');
    const mediaId = swatch.dataset.variantMediaId;

    if (!slider || !mediaId) return false;

    const slides = Array.from(slider.querySelectorAll('.card-img-slider__slide'));
    const slideIndex = slides.findIndex(function (slide) {
      return slide.dataset.mediaId === mediaId;
    });

    if (slideIndex < 0) return false;

    slider.dispatchEvent(
      new CustomEvent('card:go-to-slide', {
        detail: {
          index: slideIndex,
        },
      })
    );

    return true;
  }

  function updateImage(card, swatch) {
    const image = card.querySelector('.card__media img.easyOverlayImage, .card__media .media > img:first-of-type');

    if (!image || !swatch.dataset.variantImageSrc) return;

    image.src = swatch.dataset.variantImageSrc;

    if (swatch.dataset.variantImageSrcset) {
      image.srcset = swatch.dataset.variantImageSrcset;
    }

    if (swatch.dataset.variantImageAlt) {
      image.alt = swatch.dataset.variantImageAlt;
    }

    if (swatch.dataset.variantImageWidth) {
      image.width = swatch.dataset.variantImageWidth;
    }

    if (swatch.dataset.variantImageHeight) {
      image.height = swatch.dataset.variantImageHeight;
    }
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.card__color_variants-swatch');

    if (!swatch) return;

    const card = swatch.closest('.card');

    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    setActiveSwatch(swatch);

    if (updateSlider(card, swatch)) return;

    updateImage(card, swatch);
  });
})();
